import { render, staticRenderFns } from "./newRule.vue?vue&type=template&id=38f00d02&scoped=true"
import script from "./newRule.vue?vue&type=script&lang=js"
export * from "./newRule.vue?vue&type=script&lang=js"
import style0 from "./newRule.vue?vue&type=style&index=0&id=38f00d02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f00d02",
  null
  
)

export default component.exports